/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ConditionKind = {
    TimeOfDay: 'TimeOfDay',
    DayOfWeek: 'DayOfWeek',
    DateRange: 'DateRange',
    LicensePlate: 'LicensePlate',
    LicensePlateRegex: 'LicensePlateRegex',
    Event: 'Event'
} as const;
export type ConditionKind = typeof ConditionKind[keyof typeof ConditionKind];

